import { defaultFormItemLayout, rules } from '../../../modules/FormItems'
import React from 'react'
import { Col, Form, Input, Row, Select } from 'antd'

const { TextArea } = Input

function SupportTicketForm(props) {
  const { getFieldDecorator } = props.form

  return (
    <Form layout="vertical" name="control-hooks">
      <Row>
        <Col span={24}>
          <Form.Item {...defaultFormItemLayout} label={'url'}>
            {getFieldDecorator('url', {
              initialValue: window.location.href,
              rules: rules.select,
            })(<Input />)}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item {...defaultFormItemLayout} label={'Problem Description'}>
            {getFieldDecorator('description', {
              initialValue: `Problem Title: 
Problem Description: 
Relevant Document Ids/Codes:`,
              rules: rules.select,
            })(<TextArea placeholder="Description" rows={8} />)}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item {...defaultFormItemLayout} label={'Priority'}>
            {getFieldDecorator('priority', {
              rules: rules.select,
            })(
              <Select defaultValue="Standard">
                <Select.Option value="Low">Low</Select.Option>
                <Select.Option value="Standard">Standard</Select.Option>
                <Select.Option value="High">High</Select.Option>
                <Select.Option value="Critical">Critical</Select.Option>
                <Select.Option value="Blocker">Blocker</Select.Option>
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item {...defaultFormItemLayout} label={'Type Of Problem'}>
            {getFieldDecorator('type', {
              rules: rules.select,
            })(
              <Select>
                <Select.Option value="Visual bug">Visual bug</Select.Option>
                <Select.Option value="System Crash">System Crash</Select.Option>
                <Select.Option value="Wrong Data">Wrong Data</Select.Option>
                <Select.Option value="Access Problem">Access Problem</Select.Option>
                <Select.Option value="Other">Other</Select.Option>
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

export default Form.create()(SupportTicketForm)
